<template>
  <div class="shngties">
    <div class="shngties-background" @scroll="BaCoScrollqb($event)">
      <div class="shappHelmetysen">商场活动<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="shngties-spce"></div>
      <div class="shngties-actity shngties-fill" v-for="ershngvits in shngvits" :key="ershngvits.ID">
        <img :src="ershngvits.IMAGE_URL" alt="">
        <div class="shngties-actity-actise" v-if="ershngvits.STATE == '0'">进行中</div>
        <div class="shngties-actity-actise" v-else-if="ershngvits.STATE == '1'">已结束</div>
        <div class="shngties-actity-actise" v-else-if="ershngvits.STATE == '2'">未开始</div>
        <div class="shngties-actity-conten">
          <div class="shngties-actity-conten-left">
            <p class="shngties-actity-conten-left-test">{{ershngvits.NAME}}</p>
            <p class="shngties-actity-conten-left-time">{{ershngvits.STATE_DATE}} -- {{ershngvits.END_DATE}}</p>
          </div>
          <router-link :to="{path: 'Actvas',query: {shavid: ershngvits.ID}}"><p class="shngties-actity-conten-right">点击查看</p></router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      shngvits: '',
      shngagesng: 1,
      shngctes: ''
    }
  },
  created(){
    // 商场活动
    this.$axios.post('app/mallActivity',this.$qs.stringify({
      IS_NOT_USE: '0',
      showCount: '12',
      currentPage: this.shngagesng
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.shngvits = res.data.varList;
      this.shngctes = res.data.page.totalPage;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 滚动条触底的时候触发
    BaCoScrollqb(e) {
      // 滚动条卷起的高度
      let scrollTop = e.target.scrollTop;
      let scrollHeight = e.target.scrollHeight;
      let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
      let currentHeight = scrollTop + offsetHeight;
      if(currentHeight - scrollHeight > 0 && this.shngagesng < this.shngctes){
        this.shngagesng = this.shngagesng + 1;
        // 滚动条触底的时候渲染新的数据
        this.$axios.post('app/mallActivity',this.$qs.stringify({
          IS_NOT_USE: '0',
          showCount: '12',
          currentPage: this.shngagesng
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          this.shngvits = [...this.shngvits,...res.data.varList];
        })
        .catch(() => {
          // console.log('未登录获取数据失败');
        });
      }
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/shngties.css";
</style>